import { Dashboard } from '../Model/Dashboard';
import { Notice } from '../../Notice/Model/Notice';
import { RootState } from '../../Presentation/store';

export const selectDashboard = (s: RootState): Dashboard | undefined =>
  s.dashboard.stats;

export const selectDashboardRecent = (s: RootState): Notice[] => s.dashboard.recent;

export const selectDashboardTotalSlotCount = (s: RootState): number | undefined => s.dashboard.stats?.total;
export const selectDashboardRunningSlotCount = (s: RootState): number | undefined => s.dashboard.stats?.active;
export const selectDashboardEndTodaySlotCount = (s: RootState):number | undefined => s.dashboard.stats?.ending_today;

export const selectDashboardLoading = (s: RootState): boolean => s.dashboard.loading;
